import { Button } from "@/components/ui/button";
import { Edit } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SubscriptionOnlyButton } from "../SubscriptionOnlyButton/SubscriptionOnlyButton";
import { ValidationSuscriptionButton } from "@/common/enums/enums";
import { NewNoteSidebar } from "../visits/NewNoteSidebar";
import { useState } from "react";

interface VisitHeaderProps {
  title: string;
  onEditTitleClick: () => void;
  onAddRecording: () => void;
}

export const VisitHeader = ({
  title,
  onEditTitleClick,
  onAddRecording,
}: VisitHeaderProps): JSX.Element => {
  const [isNewNoteOpen, setIsNewNoteOpen] = useState(false);

  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-2">
        <h1 className="text-2xl font-bold">{title}</h1>
        <Button
          aria-label="Edit title"
          size="icon"
          variant="ghost"
          onClick={onEditTitleClick}
        >
          <Edit className="w-5 h-5" />
        </Button>
      </div>
      <div className="flex space-x-2">
        <SubscriptionOnlyButton
          validations={[
            ValidationSuscriptionButton.PLAN_FREE_TRIAL,
            ValidationSuscriptionButton.RECORDING_USAGES,
          ]}
          onClick={() => {
            setIsNewNoteOpen(true);
          }}
        >
          {t("visit.generateNote")}
        </SubscriptionOnlyButton>
        <SubscriptionOnlyButton
          validations={[
            ValidationSuscriptionButton.PLAN_FREE_TRIAL,
            ValidationSuscriptionButton.RECORDING_USAGES,
          ]}
          onClick={onAddRecording}
        >
          {t("visit.addRecording")}
        </SubscriptionOnlyButton>
      </div>
      <NewNoteSidebar open={isNewNoteOpen} onOpenChange={setIsNewNoteOpen} />
    </div>
  );
};
